export default "__VITE_ASSET__Cm5zvL6k__"